import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class DeleteDeviceAccessoryRequestService {
  private baseUrl = this.appProfile.ampmUs+'/ems/fhir';
  private tenantId = this.appProfile.tenant;
  private apiVersion = '1.0.0';

  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) { }

  deleteDeviceRequest(tenantId: string, token: string, deviceRequestId: string): Observable<any> {
    const url = `${this.baseUrl}/${tenantId}/DeviceRequest/${deviceRequestId}`;

    const headers = new HttpHeaders({
      'X-tenant-Id': this.tenantId,
      'api-version': this.apiVersion,
      'Authorization': `Bearer ${this.authService.accessToken}`,
    });

    return this.http.delete(url, { headers });
  }
  getTenantId(): string {
    return this.tenantId; // Assuming tenantId is stored in AuthService
  }
}
